import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-mobile-redirect-book',
    template: '',
    standalone: false
})
export class MobileRedirectBookComponent implements OnInit {
  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.router.navigate(['/book', id]);
    }
  }
}
